import { render, staticRenderFns } from "./add3.vue?vue&type=template&id=780b271e&scoped=true&"
import script from "./add3.vue?vue&type=script&lang=js&"
export * from "./add3.vue?vue&type=script&lang=js&"
import style0 from "./add3.vue?vue&type=style&index=0&id=780b271e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b271e",
  null
  
)

export default component.exports